import { isPlausiblePlayKey } from '../../utils/guestSession'

/**
 * What to do when someone opens a /guest/<key> play link.
 *
 * The only case worth pausing on is a link for a DIFFERENT guest than the one
 * already stored: redeeming it replaces the stored session, and if the player
 * never saved the link for the session they're replacing, those games become
 * unreachable. So that case asks first; everything else just gets on with it.
 *
 * A key the server could never have minted (truncated by a chat client, a
 * stray fragment) is 'invalid' rather than redeemed: the server would answer
 * it with a brand NEW guest, which silently replaces the stored session with
 * a stranger — the one thing a returning player must never trip into.
 */
export type GuestLinkAction =
  /** No usable key in the URL. */
  | 'invalid'
  /** Redeem it now. */
  | 'claim'
  /** Already playing as a different guest — confirm before switching. */
  | 'confirm'

export const guestLinkAction = (linkToken: unknown, currentToken?: string | null): GuestLinkAction => {
  if (!isPlausiblePlayKey(linkToken)) {
    return 'invalid'
  }

  if (currentToken && currentToken !== linkToken) {
    return 'confirm'
  }

  return 'claim'
}
